import React from 'react';
import '../../../assests/css/students/Vision.css';

const Vision = () => {
  return (
    <div className="vision-container">
      <div className="card-wrapper">
        {/* Left Side - Content */}
        <div className="content-section">
          <h1 className="title">Our Vision</h1>
          
          <p className="description">
            To become a leading institution of higher education recognized for
            academic excellence, innovation, and community engagement, empowering
            students to achieve their full potential and contribute meaningfully
            to society.
          </p>

          <div className="vision-points">
            <div className="point">
              <span className="icon">⚡</span>
              <p>To become a leading institution recognized for academic excellence</p>
            </div>

            <div className="point">
              <span className="icon">⚡</span>
              <p>Foster innovation and community engagement</p>
            </div>

            <div className="point">
              <span className="icon">⚡</span>
              <p>Empower students to achieve their full potential and contribute to society</p>
            </div>
          </div>
        </div>

        {/* Right Side - Circle with Icon */}
        <div className="circle-section">
          <div className="main-circle">
            <div className="icon-wrapper">
              <span className="vision-icon">🎯</span>
            </div>
          </div>
          {/* Decorative circles on the right with animation */}
          <div className="decorative-circle large"></div>
          <div className="decorative-circle small"></div>
        </div>
      </div>
    </div>
  );
};

export default Vision;